export default "__VITE_ASSET__IyI7O_n7__"